import { render } from "./PromptDialog.vue?vue&type=template&id=2640c548&scoped=true"
import script from "./PromptDialog.vue?vue&type=script&lang=js"
export * from "./PromptDialog.vue?vue&type=script&lang=js"

import "./PromptDialog.vue?vue&type=style&index=0&id=2640c548&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2640c548"]])

export default __exports__